export default {
  header: {
    back: '返回',
    currentPage: '当前页面:',
    width: '宽度',
    editData: '编辑数据',
    chinese: '中文',
    english: 'English',
    save: '保存',
    toPriview: '预览',
    toEdit: '编辑'
  },
  model: {
    addModel: '添加模块'
  },
  page: {
    setUpPage: '页面设置',
    show: '显示',
    hide: '隐藏',
    add: '添加',
    edit: '编辑',
    delete: '删除',
    page: '页面',
    name: '名称',
    path: '附加路径',
    toIndex: '设为首页',
    title: '标题',
    onboardingPage: '这是入职问卷页面, 请前往入职管理页面管理问卷。',
    onboardingPageTitle: '入职问卷',
    satisfactionSurveyPageTitle: '满意度调查',
    postApplicantPageTitle: '问卷'
  },
  component: {
    add: '添加',
    edit: '编辑',
    component: '模块'
  },
  theme: {
    setUptheme: '主题设置',
    bgColor: '背景颜色',
    btnColor: '按钮颜色'
  },
  common: {
    edit: '编辑',
    confirm: '确 定',
    cancel: '取 消',
    delete: '删 除',
    addComponent: '添加组件',
    editComponent: '编辑组件',
    component: '模块'
  },
  promotionLink: {
    menu: '推广链接',
    company: '公司链接',
    mobileJobList: '手机职位列表链接',
    addInTalentPool: '添加到人才库链接',
    copyLink: '请按CTRL+C复制地址'
  }
}
